export const setupToolCall = (llmRequestRefs: any, currentMessageRef: any, updateElementInProgress: any, setMessages: any, message: any) => {
    if (!llmRequestRefs.current.aiMessage) return;

    if (llmRequestRefs.current.intervalId) {
        clearInterval(llmRequestRefs.current.intervalId);
        llmRequestRefs.current.intervalId = null;
        currentMessageRef.current.message = {
            ...currentMessageRef.current.message,
            content: []
        };
    }
    updateElementInProgress(message.id, 'add');
    llmRequestRefs.current.aiMessage.message.tool_calls.push({
        id: message.id,
        name: message.name,
        args: message.args
    });
    const toolCallsLength = llmRequestRefs.current.aiMessage.message.tool_calls.length;
    llmRequestRefs.current.toolCalls[message.id] = llmRequestRefs.current.aiMessage.message.tool_calls[toolCallsLength-1];
    setMessages((prev: any) => prev.deepCopy());
}
